<div class="table-page table-page--fill">

    <header class="header">
        <div class="title-row">
            <button class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
                <i class="fa fa-arrow-right"></i>
            </button>

            <div class="title-block">
                <h1 class="title">سوابق سرویس و تعمیرات</h1>

                <span class="muted">
                    {{ vehicle.ownerName }} · پلاک
                    <span class="num">{{ otherService.returnCorrectPlate(vehicle.plate) }}</span> · آخرین کیلومتر:
                    <span class="num">{{ lastKmText | faNum }}</span>
                </span>
            </div>

            <div class="actions">
                <button class="btn btn-ghost" id="filterToggle" [attr.aria-expanded]="filtersOpen"
                    aria-controls="filtersWrap" (click)="toggleFilters()">
                    <i class="fa fa-sliders"></i> فیلتر
                    <span class="badge" id="filterBadge" [class.show]="filterCount > 0">
                        {{ filterCount | faNum }}
                    </span>
                    <i class="fa fa-chevron-down chev"></i>
                </button>

                <ng-container *ngIf="permissions.bRepairs_User_Save">
                    <span class="actions-sep"></span>

                    <button class="btn btn-primary" id="addBtn" type="button"
                        data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="startCreate()">
                        <i class="fa fa-plus"></i> ثبت تعمیرات
                    </button>
                </ng-container>
            </div>
        </div>

        <!-- ===== پنل فیلتر تاشو ===== -->
        <div class="collapsible" id="filtersWrap" [class.collapsed]="!filtersOpen">
            <div class="collapsible-inner">
                <form class="filters" id="filtersPanel" [formGroup]="filterForm">
                    <div class="field">
                        <span class="field-label">از تاریخ</span>
                        <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" placeholder="مثال: ۱۴۰۵/۰۱/۰۱" class="control num"
                                formControlName="fromDate" readonly />
                        </ng-persian-datepicker>
                    </div>

                    <div class="field">
                        <span class="field-label">تا تاریخ</span>
                        <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" placeholder="مثال: ۱۴۰۵/۱۲/۲۹" class="control num"
                                formControlName="toDate" readonly />
                        </ng-persian-datepicker>
                    </div>

                    <label class="field">
                        <span class="field-label">علت</span>
                        <input type="text" class="control" placeholder="مثال: ترمز، موتور" formControlName="reason" />
                    </label>

                    <label class="field">
                        <span class="field-label">نام تعمیرکار</span>
                        <input type="text" class="control" placeholder="مثال: احمدی" formControlName="repairer" />
                    </label>

                    <div class="field">
                        <span class="field-label">بازه سریع</span>
                        <div class="segment" id="periodSeg">
                            <button type="button" class="seg-btn" [class.active]="activePeriod === ''"
                                (click)="setPeriod('')">همه</button>
                            <button type="button" class="seg-btn" [class.active]="activePeriod === '7'"
                                (click)="setPeriod('7')">۷ روز</button>
                            <button type="button" class="seg-btn" [class.active]="activePeriod === '30'"
                                (click)="setPeriod('30')">۳۰ روز</button>
                        </div>
                    </div>

                    <div class="filter-actions">
                        <button type="button" class="btn btn-primary" id="searchBtn" (click)="applyFilters()">
                            <i class="fa fa-search"></i> جستجو
                        </button>
                        <button type="button" class="btn btn-ghost" id="resetBtn" [hidden]="!hasActiveFilters"
                            (click)="resetFilters()">
                            <i class="fa fa-undo"></i> حذف فیلترها
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </header>

    <!-- ===== کارت جدول ===== -->
    <section class="card" id="card">
        <div class="table-toolbar">
            <div class="search-wrap">
                <input class="control" id="fSearch" placeholder="جستجو در جدول: تاریخ، تعمیرکار، علت..."
                    [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" />
                <i class="fa fa-search"></i>
            </div>

            <div class="toolbar-actions">
                <button class="btn btn-soft" type="button" (click)="printReport()">
                    <i class="fa fa-print"></i> چاپ
                </button>

                <button class="btn btn-soft" type="button" (click)="exportExcel()">
                    <i class="fa fa-file-excel-o"></i> خروجی اکسل
                </button>
            </div>
        </div>

        <div class="body">
            <div class="loader" id="loader" [class.show]="loading" role="status" aria-live="polite">
                <div class="spinner"></div>
                <span>در حال دریافت اطلاعات…</span>
            </div>

            <div class="state" id="stEmpty" [class.show]="!loading && !hasError && filteredRows.length === 0">
                <div class="ico-big"><i class="fa fa-inbox"></i></div>
                <h4>با این فیلترها نتیجه‌ای پیدا نشد!</h4>
                <span class="muted">فیلترها را تغییر دهید و دوباره جستجو کنید.</span>
                <div class="empty-actions">
                    <button class="btn btn-ghost" type="button" id="editFiltersBtn" (click)="openFilters()">
                        <i class="fa fa-pencil"></i> تغییر فیلترها
                    </button>
                    <button class="btn btn-primary" type="button" id="clearFiltersBtn" [hidden]="!hasActiveFilters"
                        (click)="resetFilters()">
                        <i class="fa fa-undo"></i> حذف فیلترها
                    </button>
                </div>
            </div>

            <div class="state error" id="stError" [class.show]="hasError">
                <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
                <h4>دریافت اطلاعات با خطا مواجه شد</h4>
                <span class="muted">اتصال به سرور را بررسی و دوباره تلاش کنید.</span>
                <button class="btn btn-primary retry" type="button" id="retryBtn" (click)="applyFilters()">
                    <i class="fa fa-refresh"></i> تلاش مجدد
                </button>
            </div>

            <div class="table-scroll" id="tableWrap" (scroll)="hideTooltip()">
                <table>
                    <thead id="thead">
                        <tr>
                            <th class="col-ops sticky-first">عملیات</th>
                            <th class="col-num">#</th>
                            <th>تاریخ</th>
                            <th>کاربر ثبت‌کننده</th>
                            <th>تعمیرکار</th>
                            <th>علت</th>
                            <th>کیلومتر</th>
                            <th class="col-amt">مبلغ (ریال)</th>
                        </tr>
                    </thead>

                    <tbody id="tbody">
                        <tr *ngFor="let row of pagedRows; let i = index; trackBy: trackById">
                            <td class="col-ops sticky-first">
                                <div class="row-ops">
                                    <button class="ico" type="button" *ngIf="permissions.bRepairs_User_Edit"
                                        aria-label="ویرایش" (mouseenter)="showTooltip($event, 'ویرایش')"
                                        (mouseleave)="hideTooltip()" (click)="openEditModal(row)">
                                        <i class="fa fa-pencil"></i>
                                    </button>

                                    <button class="ico" type="button" *ngIf="permissions.bRepairs_User_Delete"
                                        aria-label="حذف" (mouseenter)="showTooltip($event, 'حذف')"
                                        (mouseleave)="hideTooltip()" (click)="confirmDelete(row)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>

                            <td class="col-num num">{{ (currentPage - 1) * pageSize + i + 1 | faNum }}</td>
                            <td class="num">{{ row.strDate | faNum }}</td>
                            <td>{{ row.strUserSaved | faNum }}</td>
                            <td>{{ row.strRepairman | faNum }}</td>
                            <td>{{ row.strReason | faNum }}</td>
                            <td class="num">{{ row.kmText | faNum }}</td>
                            <td class="col-amt num">{{ row.costText | faNum }}</td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td class="sticky-first"></td>
                            <td colspan="6" class="label">
                               تعداد کل : <span class="num">{{ (filteredRows.length | number) | faNum }}</span>
                            </td>
                            <td class="total num">{{ filteredTotalText | faNum }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length"
            [pageSizeOptions]="pageSizeOptions" (pageChange)="goToPage($event)"
            (pageSizeChange)="onPageSizeChange($event)">
        </app-table-pagination>
    </section>

    <!-- ===== جدول خروجی چاپ/اکسل: فقط موقع خروجی گرفتن ساخته می‌شود ===== -->
    <div *ngIf="isExporting">
        <div id="print-section" class="print-only">
            <div class="row dirI">
                <div class="col-10 text-center align-items-center border">
                    <p class="mt-2 fw-bold">{{ loggedInUser }}</p>
                    <p>
                        گزارش تعمیرات {{ vehicle.ownerName }} با شماره پلاک
                        <span class="license-plate" style="height: auto; margin-top: .1rem;">{{ reversedPlate }}</span>
                        در {{ vehicle.hoze }} از تاریخ {{ filterForm.value.fromDate | faNum }}
                        تا تاریخ {{ filterForm.value.toDate | faNum }}
                    </p>
                </div>
                <div class="col-2 text-center align-items-center border">
                    <p class="p-2">تاریخ تهیه</p>
                    {{ currentDate | faNum }}
                </div>
            </div>

            <div class="w-100 bg-th-blue" *ngIf="filteredRows.length > 0">
                <div class="d-flex justify-content-around align-items-center flex-wrap dirI">
                    <span class="text-white">تعداد کل : {{ (filteredRows.length | number) | faNum }} مورد</span>
                    <span class="text-white">مجموع هزینه : {{ filteredTotalText | faNum }} ریال</span>
                </div>
            </div>

            <div class="table-responsive table-striped dirI">
                <table class="table table-bordered" id="excel-table-repairsRep">
                    <thead>
                        <tr class="text-center f12">
                            <th scope="col">ردیف</th>
                            <th scope="col">تاریخ</th>
                            <th scope="col">کیلومتر</th>
                            <th scope="col">موضوع</th>
                            <th scope="col">تعمیرکار</th>
                            <th scope="col">هزینه (ریال)</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr class="text-center f12" *ngFor="let row of filteredRows; let i = index">
                            <th class="text-secondary">{{ i + 1 | faNum }}</th>
                            <th class="text-secondary">{{ row.strDate | faNum }}</th>
                            <th class="text-secondary">{{ row.kmText }}</th>
                            <th class="text-secondary">{{ row.strReason | faNum }}</th>
                            <th class="text-secondary">{{ row.strRepairman | faNum }}</th>
                            <th class="text-secondary">{{ row.costText }}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- ===== مودال ثبت / ویرایش تعمیرات ===== -->
    <div class="modal fade rtl" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        {{ isEditMode ? 'ویرایش تعمیرات' : 'ثبت تعمیرات' }}
                    </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
                </div>

                <div class="modal-body modal-body-scroll">
                    <form [formGroup]="repairForm" class="row g-3">
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <span class="field-label">تاریخ <span class="text-danger">*</span></span>
                                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                    [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                    <input type="text" formControlName="strDate" class="control num" readonly />
                                </ng-persian-datepicker>
                            </div>
                        </div>

                        <div class="col-12 col-md-6">
                            <label class="field">
                                <span class="field-label">هزینه کل ( ریال ) <span class="text-danger">*</span></span>
                                <input type="text" class="control num" formControlName="iTotalCost"
                                    (keypress)="onNumberKeyPress($event)" />
                            </label>
                        </div>

                        <div class="col-12 col-md-6">
                            <label class="field">
                                <span class="field-label">موضوع</span>
                                <input type="text" class="control" formControlName="strReason" />
                            </label>
                        </div>

                        <div class="col-12 col-md-6">
                            <label class="field">
                                <span class="field-label">کیلومتر فعلی</span>
                                <input type="text" class="control num" formControlName="iKM"
                                    (keypress)="onNumberKeyPress($event)" />
                            </label>
                        </div>

                        <div class="col-12">
                            <label class="field">
                                <span class="field-label">نام تعمیر کار</span>
                                <input type="text" class="control" formControlName="strRepairman" />
                            </label>
                        </div>

                        <div class="col-12">
                            <label class="field">
                                <span class="field-label">توضیحات</span>
                                <textarea class="control" formControlName="strComment"></textarea>
                            </label>
                        </div>

                        <!-- سرویس‌های ثبت‌شده روی این تعمیرات -->
                        <div class="col-12" *ngIf="serviceItems.length">
                            <span class="field-label d-block mb-2">سرویس‌ها و اقدامات</span>

                            <div class="row g-2">
                                <ng-container *ngFor="let item of serviceItems">
                                    <div class="col-12 col-md-6 col-xl-4"
                                        *ngIf="item.tiStatus !== ServiceStatus.None || item.bExpanded">
                                        <div class="card h-100 p-3">
                                            <div class="d-flex align-items-center justify-content-between gap-2">
                                                <strong>{{ item.strTitle | faNum }}</strong>
                                                <span class="tag" [ngClass]="statusDisplay(item.tiStatus).tag">
                                                    {{ statusDisplay(item.tiStatus).label }}
                                                </span>
                                            </div>

                                            <div class="muted mt-2">
                                                هزینه :
                                                <strong class="num">
                                                    {{ item.iCost != 0 ? (groupDigits(item.iCost) | faNum) + ' ریال' : '- - -' }}
                                                </strong>
                                            </div>

                                            <div class="muted">
                                                توضیحات :
                                                <strong>{{ item.strComment !== '' ? item.strComment : '- - -' }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <div class="col-12 d-flex flex-wrap justify-content-center gap-2 pt-2">
                            <button type="button" class="btn btn-soft" (click)="openServiceTypes()">
                                <i class="fa fa-list-ul"></i> انتخاب سرویس‌ها
                            </button>

                            <button type="button" class="btn btn-soft" (click)="fileInput.click()">
                                <i class="fa fa-image"></i> تصویر فاکتور
                            </button>

                            <input hidden type="file" #fileInput (change)="onImageSelected($event)" />
                        </div>

                        <div class="col-12 text-center" *ngIf="repairForm.value.strImage">
                            <img class="invoice-img" id="fullScreen_" alt="تصویر فاکتور"
                                [src]="'data:image/jpeg;base64,' + repairForm.value.strImage"
                                (click)="toggleImageFullScreen()" />
                        </div>
                    </form>
                </div>

                <div class="modal-footer">
                    <div class="modal-footer-split w-100">
                        <div class="footer-main-actions">
                            <button type="button" class="btn btn-ghost" data-bs-dismiss="modal">انصراف</button>

                            <button type="button" class="btn btn-primary" (click)="saveRepair()"
                                *ngIf="!isEditMode && permissions.bRepairs_User_Save">
                                ذخیره
                            </button>

                            <button type="button" class="btn btn-primary" (click)="updateRepair()"
                                *ngIf="isEditMode && permissions.bRepairs_User_Edit">
                                ویرایش
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== مودال انتخاب سرویس‌ها ===== -->
    <div class="modal fade rtl" id="serviceType_Modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">سرویس‌ها و اقدامات</h5>

                    <button type="button" class="btn-close" (click)="backToRepairForm()" aria-label="بستن"></button>
                </div>

                <div class="modal-body modal-body-scroll">
                    <div *ngFor="let item of serviceItems; let i = index" class="card mb-2 p-3">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                            <strong>{{ item.strTitle | faNum }}</strong>

                            <i class="fa pointer" [ngClass]="item.bExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
                                [attr.aria-expanded]="item.bExpanded" role="button" tabindex="0"
                                (click)="item.bExpanded = !item.bExpanded"></i>
                        </div>

                        <div class="segment mt-3">
                            <button type="button" class="seg-btn" [class.active]="item.tiStatus === ServiceStatus.None"
                                (click)="setServiceStatus(i, ServiceStatus.None)">بدون اقدام</button>
                            <button type="button" class="seg-btn" [class.active]="item.tiStatus === ServiceStatus.Inspection"
                                (click)="setServiceStatus(i, ServiceStatus.Inspection)">بازدید</button>
                            <button type="button" class="seg-btn" [class.active]="item.tiStatus === ServiceStatus.Repair"
                                (click)="setServiceStatus(i, ServiceStatus.Repair)">تعمیر</button>
                            <button type="button" class="seg-btn" [class.active]="item.tiStatus === ServiceStatus.Replacement"
                                (click)="setServiceStatus(i, ServiceStatus.Replacement)">تعویض</button>
                        </div>

                        <div class="collapsible" [class.collapsed]="!item.bExpanded">
                            <div class="collapsible-inner">
                                <div class="row g-2 pt-3">
                                    <div class="col-12 col-md-5">
                                        <label class="field">
                                            <span class="field-label">هزینه (ریال)</span>
                                            <input type="text" class="control num" [(ngModel)]="item.iCost"
                                                placeholder="مثلاً ۱٬۵۰۰٬۰۰۰" (keypress)="onNumberKeyPress($event)" />
                                        </label>
                                    </div>

                                    <div class="col-12 col-md-7">
                                        <label class="field">
                                            <span class="field-label">توضیحات</span>
                                            <textarea class="control" [(ngModel)]="item.strComment"
                                                placeholder="توضیح اقدام انجام‌شده"></textarea>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="modal-footer-split w-100">
                        <div class="footer-main-actions">
                            <button type="button" class="btn btn-primary" (click)="backToRepairForm()">
                                <i class="fa fa-check"></i> تایید
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== تولتیپ شناور ===== -->
    <div class="tooltip" role="tooltip" [class.show]="tooltip.visible"
        [style.left.px]="tooltip.x" [style.top.px]="tooltip.y">
        {{ tooltip.text }}
    </div>
</div>
